/**
 * podravka.io
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.7.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import NutrientWriteEmbed from './NutrientWriteEmbed';

/**
 * The RecipeNutritionWriteEmbed model module.
 * @module model/RecipeNutritionWriteEmbed
 * @version 1.7.2
 */
class RecipeNutritionWriteEmbed {
    /**
     * Constructs a new <code>RecipeNutritionWriteEmbed</code>.
     * The &#x60;RecipeNutrition-WriteEmbed&#x60; definition is used as a part of other definitions when creating or updating resources.  It is used in the following definitions as an embed: * Recipe-Create * Recipe-Update * Recipe-VersionWrite 
     * @alias module:model/RecipeNutritionWriteEmbed
     * @param baseAmount {Number} 
     * @param baseUnit {String} 
     */
    constructor(baseAmount, baseUnit) { 
        
        RecipeNutritionWriteEmbed.initialize(this, baseAmount, baseUnit);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, baseAmount, baseUnit) { 
        obj['base_amount'] = baseAmount;
        obj['base_unit'] = baseUnit;
    }

    /**
     * Constructs a <code>RecipeNutritionWriteEmbed</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/RecipeNutritionWriteEmbed} obj Optional instance to populate.
     * @return {module:model/RecipeNutritionWriteEmbed} The populated <code>RecipeNutritionWriteEmbed</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new RecipeNutritionWriteEmbed();

            if (data.hasOwnProperty('base_amount')) {
                obj['base_amount'] = ApiClient.convertToType(data['base_amount'], 'Number');
            }
            if (data.hasOwnProperty('base_unit')) {
                obj['base_unit'] = ApiClient.convertToType(data['base_unit'], 'String');
            }
            if (data.hasOwnProperty('energy_kcal')) {
                obj['energy_kcal'] = ApiClient.convertToType(data['energy_kcal'], 'Number');
            }
            if (data.hasOwnProperty('energy_kilojoules')) {
                obj['energy_kilojoules'] = ApiClient.convertToType(data['energy_kilojoules'], 'Number');
            }
            if (data.hasOwnProperty('fats')) {
                obj['fats'] = NutrientWriteEmbed.constructFromObject(data['fats']);
            }
            if (data.hasOwnProperty('saturated_fatty_acids')) {
                obj['saturated_fatty_acids'] = NutrientWriteEmbed.constructFromObject(data['saturated_fatty_acids']);
            }
            if (data.hasOwnProperty('monounsaturated_fatty_acids')) {
                obj['monounsaturated_fatty_acids'] = NutrientWriteEmbed.constructFromObject(data['monounsaturated_fatty_acids']);
            }
            if (data.hasOwnProperty('polyunsaturated_fatty_acids')) {
                obj['polyunsaturated_fatty_acids'] = NutrientWriteEmbed.constructFromObject(data['polyunsaturated_fatty_acids']);
            }
            if (data.hasOwnProperty('carbohydrates')) {
                obj['carbohydrates'] = NutrientWriteEmbed.constructFromObject(data['carbohydrates']);
            }
            if (data.hasOwnProperty('sugars')) {
                obj['sugars'] = NutrientWriteEmbed.constructFromObject(data['sugars']);
            }
            if (data.hasOwnProperty('polyols')) {
                obj['polyols'] = NutrientWriteEmbed.constructFromObject(data['polyols']);
            }
            if (data.hasOwnProperty('starch')) {
                obj['starch'] = NutrientWriteEmbed.constructFromObject(data['starch']);
            }
            if (data.hasOwnProperty('fibers')) {
                obj['fibers'] = NutrientWriteEmbed.constructFromObject(data['fibers']);
            }
            if (data.hasOwnProperty('protein')) {
                obj['protein'] = NutrientWriteEmbed.constructFromObject(data['protein']);
            }
            if (data.hasOwnProperty('salt')) {
                obj['salt'] = NutrientWriteEmbed.constructFromObject(data['salt']);
            }
            if (data.hasOwnProperty('vitamin_a')) {
                obj['vitamin_a'] = NutrientWriteEmbed.constructFromObject(data['vitamin_a']);
            }
            if (data.hasOwnProperty('vitamin_d')) {
                obj['vitamin_d'] = NutrientWriteEmbed.constructFromObject(data['vitamin_d']);
            }
            if (data.hasOwnProperty('vitamin_e')) {
                obj['vitamin_e'] = NutrientWriteEmbed.constructFromObject(data['vitamin_e']);
            }
            if (data.hasOwnProperty('vitamin_k')) {
                obj['vitamin_k'] = NutrientWriteEmbed.constructFromObject(data['vitamin_k']);
            }
            if (data.hasOwnProperty('vitamin_c')) {
                obj['vitamin_c'] = NutrientWriteEmbed.constructFromObject(data['vitamin_c']);
            }
            if (data.hasOwnProperty('vitamin_b6')) {
                obj['vitamin_b6'] = NutrientWriteEmbed.constructFromObject(data['vitamin_b6']);
            }
            if (data.hasOwnProperty('vitamin_b12')) {
                obj['vitamin_b12'] = NutrientWriteEmbed.constructFromObject(data['vitamin_b12']);
            }
            if (data.hasOwnProperty('thiamine')) {
                obj['thiamine'] = NutrientWriteEmbed.constructFromObject(data['thiamine']);
            }
            if (data.hasOwnProperty('riboflavin')) {
                obj['riboflavin'] = NutrientWriteEmbed.constructFromObject(data['riboflavin']);
            }
            if (data.hasOwnProperty('niacin')) {
                obj['niacin'] = NutrientWriteEmbed.constructFromObject(data['niacin']);
            }
            if (data.hasOwnProperty('folic_acid')) {
                obj['folic_acid'] = NutrientWriteEmbed.constructFromObject(data['folic_acid']);
            }
            if (data.hasOwnProperty('biotin')) {
                obj['biotin'] = NutrientWriteEmbed.constructFromObject(data['biotin']);
            }
            if (data.hasOwnProperty('pantothenic_acid')) {
                obj['pantothenic_acid'] = NutrientWriteEmbed.constructFromObject(data['pantothenic_acid']);
            }
            if (data.hasOwnProperty('potassium')) {
                obj['potassium'] = NutrientWriteEmbed.constructFromObject(data['potassium']);
            }
            if (data.hasOwnProperty('chlorine')) {
                obj['chlorine'] = NutrientWriteEmbed.constructFromObject(data['chlorine']);
            }
            if (data.hasOwnProperty('calcium')) {
                obj['calcium'] = NutrientWriteEmbed.constructFromObject(data['calcium']);
            }
            if (data.hasOwnProperty('phosphorus')) {
                obj['phosphorus'] = NutrientWriteEmbed.constructFromObject(data['phosphorus']);
            }
            if (data.hasOwnProperty('magnesium')) {
                obj['magnesium'] = NutrientWriteEmbed.constructFromObject(data['magnesium']);
            }
            if (data.hasOwnProperty('iron')) {
                obj['iron'] = NutrientWriteEmbed.constructFromObject(data['iron']);
            }
            if (data.hasOwnProperty('zinc')) {
                obj['zinc'] = NutrientWriteEmbed.constructFromObject(data['zinc']);
            }
            if (data.hasOwnProperty('copper')) {
                obj['copper'] = NutrientWriteEmbed.constructFromObject(data['copper']);
            }
            if (data.hasOwnProperty('manganese')) {
                obj['manganese'] = NutrientWriteEmbed.constructFromObject(data['manganese']);
            }
            if (data.hasOwnProperty('fluoride')) {
                obj['fluoride'] = NutrientWriteEmbed.constructFromObject(data['fluoride']);
            }
            if (data.hasOwnProperty('selenium')) {
                obj['selenium'] = NutrientWriteEmbed.constructFromObject(data['selenium']);
            }
            if (data.hasOwnProperty('chromium')) {
                obj['chromium'] = NutrientWriteEmbed.constructFromObject(data['chromium']);
            }
            if (data.hasOwnProperty('molybdenum')) {
                obj['molybdenum'] = NutrientWriteEmbed.constructFromObject(data['molybdenum']);
            }
            if (data.hasOwnProperty('iodine')) {
                obj['iodine'] = NutrientWriteEmbed.constructFromObject(data['iodine']);
            }
        }
        return obj;
    }


}

/**
 * @member {Number} base_amount
 */
RecipeNutritionWriteEmbed.prototype['base_amount'] = undefined;

/**
 * @member {String} base_unit
 */
RecipeNutritionWriteEmbed.prototype['base_unit'] = undefined;

/**
 * @member {Number} energy_kcal
 */
RecipeNutritionWriteEmbed.prototype['energy_kcal'] = undefined;

/**
 * @member {Number} energy_kilojoules
 */
RecipeNutritionWriteEmbed.prototype['energy_kilojoules'] = undefined;

/**
 * @member {module:model/NutrientWriteEmbed} fats
 */
RecipeNutritionWriteEmbed.prototype['fats'] = undefined;

/**
 * @member {module:model/NutrientWriteEmbed} saturated_fatty_acids
 */
RecipeNutritionWriteEmbed.prototype['saturated_fatty_acids'] = undefined;

/**
 * @member {module:model/NutrientWriteEmbed} monounsaturated_fatty_acids
 */
RecipeNutritionWriteEmbed.prototype['monounsaturated_fatty_acids'] = undefined;

/**
 * @member {module:model/NutrientWriteEmbed} polyunsaturated_fatty_acids
 */
RecipeNutritionWriteEmbed.prototype['polyunsaturated_fatty_acids'] = undefined;

/**
 * @member {module:model/NutrientWriteEmbed} carbohydrates
 */
RecipeNutritionWriteEmbed.prototype['carbohydrates'] = undefined;

/**
 * @member {module:model/NutrientWriteEmbed} sugars
 */
RecipeNutritionWriteEmbed.prototype['sugars'] = undefined;

/**
 * @member {module:model/NutrientWriteEmbed} polyols
 */
RecipeNutritionWriteEmbed.prototype['polyols'] = undefined;

/**
 * @member {module:model/NutrientWriteEmbed} starch
 */
RecipeNutritionWriteEmbed.prototype['starch'] = undefined;

/**
 * @member {module:model/NutrientWriteEmbed} fibers
 */
RecipeNutritionWriteEmbed.prototype['fibers'] = undefined;

/**
 * @member {module:model/NutrientWriteEmbed} protein
 */
RecipeNutritionWriteEmbed.prototype['protein'] = undefined;

/**
 * @member {module:model/NutrientWriteEmbed} salt
 */
RecipeNutritionWriteEmbed.prototype['salt'] = undefined;

/**
 * @member {module:model/NutrientWriteEmbed} vitamin_a
 */
RecipeNutritionWriteEmbed.prototype['vitamin_a'] = undefined;

/**
 * @member {module:model/NutrientWriteEmbed} vitamin_d
 */
RecipeNutritionWriteEmbed.prototype['vitamin_d'] = undefined;

/**
 * @member {module:model/NutrientWriteEmbed} vitamin_e
 */
RecipeNutritionWriteEmbed.prototype['vitamin_e'] = undefined;

/**
 * @member {module:model/NutrientWriteEmbed} vitamin_k
 */
RecipeNutritionWriteEmbed.prototype['vitamin_k'] = undefined;

/**
 * @member {module:model/NutrientWriteEmbed} vitamin_c
 */
RecipeNutritionWriteEmbed.prototype['vitamin_c'] = undefined;

/**
 * @member {module:model/NutrientWriteEmbed} vitamin_b6
 */
RecipeNutritionWriteEmbed.prototype['vitamin_b6'] = undefined;

/**
 * @member {module:model/NutrientWriteEmbed} vitamin_b12
 */
RecipeNutritionWriteEmbed.prototype['vitamin_b12'] = undefined;

/**
 * @member {module:model/NutrientWriteEmbed} thiamine
 */
RecipeNutritionWriteEmbed.prototype['thiamine'] = undefined;

/**
 * @member {module:model/NutrientWriteEmbed} riboflavin
 */
RecipeNutritionWriteEmbed.prototype['riboflavin'] = undefined;

/**
 * @member {module:model/NutrientWriteEmbed} niacin
 */
RecipeNutritionWriteEmbed.prototype['niacin'] = undefined;

/**
 * @member {module:model/NutrientWriteEmbed} folic_acid
 */
RecipeNutritionWriteEmbed.prototype['folic_acid'] = undefined;

/**
 * @member {module:model/NutrientWriteEmbed} biotin
 */
RecipeNutritionWriteEmbed.prototype['biotin'] = undefined;

/**
 * @member {module:model/NutrientWriteEmbed} pantothenic_acid
 */
RecipeNutritionWriteEmbed.prototype['pantothenic_acid'] = undefined;

/**
 * @member {module:model/NutrientWriteEmbed} potassium
 */
RecipeNutritionWriteEmbed.prototype['potassium'] = undefined;

/**
 * @member {module:model/NutrientWriteEmbed} chlorine
 */
RecipeNutritionWriteEmbed.prototype['chlorine'] = undefined;

/**
 * @member {module:model/NutrientWriteEmbed} calcium
 */
RecipeNutritionWriteEmbed.prototype['calcium'] = undefined;

/**
 * @member {module:model/NutrientWriteEmbed} phosphorus
 */
RecipeNutritionWriteEmbed.prototype['phosphorus'] = undefined;

/**
 * @member {module:model/NutrientWriteEmbed} magnesium
 */
RecipeNutritionWriteEmbed.prototype['magnesium'] = undefined;

/**
 * @member {module:model/NutrientWriteEmbed} iron
 */
RecipeNutritionWriteEmbed.prototype['iron'] = undefined;

/**
 * @member {module:model/NutrientWriteEmbed} zinc
 */
RecipeNutritionWriteEmbed.prototype['zinc'] = undefined;

/**
 * @member {module:model/NutrientWriteEmbed} copper
 */
RecipeNutritionWriteEmbed.prototype['copper'] = undefined;

/**
 * @member {module:model/NutrientWriteEmbed} manganese
 */
RecipeNutritionWriteEmbed.prototype['manganese'] = undefined;

/**
 * @member {module:model/NutrientWriteEmbed} fluoride
 */
RecipeNutritionWriteEmbed.prototype['fluoride'] = undefined;

/**
 * @member {module:model/NutrientWriteEmbed} selenium
 */
RecipeNutritionWriteEmbed.prototype['selenium'] = undefined;

/**
 * @member {module:model/NutrientWriteEmbed} chromium
 */
RecipeNutritionWriteEmbed.prototype['chromium'] = undefined;

/**
 * @member {module:model/NutrientWriteEmbed} molybdenum
 */
RecipeNutritionWriteEmbed.prototype['molybdenum'] = undefined;

/**
 * @member {module:model/NutrientWriteEmbed} iodine
 */
RecipeNutritionWriteEmbed.prototype['iodine'] = undefined;






export default RecipeNutritionWriteEmbed;

